<template>
  <div>
    <div class="row" style="padding-bottom: 10px">
      <div class="col-md-2">
        <label for="starDate">{{$t('Tarixdən')}}</label>
        <el-date-picker size="small" format="dd.MM.yyyy" id="starDate" type="date" :clearable="false"
          v-model="item.startDate">
        </el-date-picker>
      </div>
      <div class="col-md-2">
        <label for="endDate">{{$t('Tarixədək')}}</label>
        <el-date-picker size="small" format="dd.MM.yyyy" id="endDate" type="date" :clearable="false"
          v-model="item.endDate">
        </el-date-picker>
      </div>
      <div class="col-md-8" style="padding-bottom: 10px">
       <label>{{$t('Axtarış_növü')}}</label>
        <div class="d-flex justify-content-start">
          <div class="d-flex flex-row">
            <el-select style="width: 90%" size="small" v-model="item.searchType">
              <el-option :label="$t('--_Bütün_--')" :value="0"></el-option>
              <el-option :label="$t('Hadisə_nömrəsi')" :value="1"></el-option>
              <el-option :label="$t('SŞ_nömrəsi')" :value="2"></el-option>
              <el-option :label="$t('DQN')" :value="3"></el-option>
              <el-option :label="$t('İştirakçılara_görə')" :value="4"></el-option>
            </el-select>
            &nbsp;
            <el-input size="small" :placeholder="$t('Axtar')" :disabled="item.searchType == 0" v-model="item.searchText">
              <template slot="prepend"> </template>
            </el-input>
            &nbsp;
            <el-button :title="$t('Axtarış')" size="small" type="primary" @keyup.enter.native="clickSearch"
              icon="el-icon-search" @click="clickSearch"></el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <el-table @row-dblclick="handleRowClick"  v-loading="loading" :data="displayData.filter(
          (data) =>
            !search ||
            data.participants.toString().includes(search) ||
            data.regionName.toLowerCase().includes(search.toLowerCase()) ||
            data.clientServiceUserName
              .toLowerCase()
              .includes(search.toLowerCase()) ||
            data.participants.toLowerCase().includes(search.toLowerCase())
        )
          " style="width: 100%">
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="row" style="margin-left: 40px; background-color: #f5f5f5; padding: 8px 0;width: 90%;">
                <div class="col-11">
                  <span style="font-size: var(--font-primary); display: inline-block;" v-html="scope.row.participants"></span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('Status')" width="300">
            <template slot-scope="scope">
              <status-label :type="scope.row.statusTypeId === 1 ? 'mediumBlue' : '' ||
                  scope.row.statusTypeId === 5
                  ? 'forestGreen' : ''" />
              {{ scope.row.statusTypeName }}
            </template>
          </el-table-column>
                    <el-table-column :label="$t('Hadisə_#')" sortable prop="dispAccidentNumber" width="120">
            <template #default="scope">
              <span style="font-weight: bold">{{ scope.row.dispAccidentNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column :label="$t('İş_#')" sortable prop="claimNumber" width="120">
          </el-table-column>
          <el-table-column :label="$t('Hadisə_məlumatları')" sortable prop="accidentDateStr" width="150">
          </el-table-column>
          <el-table-column :label="$t('Sığortalı_DQN')" sortable prop="regNumber" width="140">
          </el-table-column>
          <el-table-column :label="$t('Region')" prop="regionName" width="200">
          </el-table-column>
          <el-table-column :label="$t('Açılmış_işlərin_sayı')" prop="claimCount">
          </el-table-column>
          <el-table-column fixed="right" width="40">
            <template slot="header"> </template>
            <template slot-scope="scope">
              <el-button title="Statuslar" @click="handleStatusView(scope.row.accidentId, 'accident')"
                style="padding: 0 !important" size="mini">
                <i class="fa-solid fa-timeline"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="text-align: center">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="filter.page" :page-sizes="[10, 30, 50, 100, 200]" :page-size="filter.pagesize"
            layout="sizes, prev, pager, next" :total="this.data.length">
          </el-pagination>
        </div>
      </div>
    </div>
    <accident-status-view ref="accident" />
  </div>
</template>

<script>
import { DateToString, AddDays } from "../services/helper";
import AccidentStatusView from "./components/AccidentStatusView.vue";
import StatusLabel from "./components/StatusLabel.vue";
import {
  GetAccidentResults,
} from "src/services/common";
export default {
  components: {
    AccidentStatusView,
    StatusLabel
  },
  data() {
    return {
      loading: false,
      data: [],
      search: "",
      item: {
        startDate: null,
        endDate: null,
        searchType: 0,
        searchText: null,
        newClaim: false,
        noResponsible: false,
      },
      displayData: [],
      filter: {
        page: 1,
        pagesize: 50,
      },
    };
  },

  methods: {
    handleRowClick(item) {
      let id = item.claimId ? item.claimId : item.accidentId
      let path = item.claimId ? "../servicecenter/claim/" : "../comm/accident/"
      let routeData = this.$router.resolve({ path: path + id });
      window.open(routeData.href, "_blank");
    },
    handleStatusView(id, type) {
      this.$refs["accident"].view(id, type);
    },
    clickSearch() {
      this.filter.page = 1
      this.getData();
    },
    getData() {
      this.loading = true;
      if (this.item.searchText == "") {
        this.item.searchText = null;
      }
      this.item.startDate = DateToString(this.item.startDate);
      this.item.endDate = DateToString(this.item.endDate);
      GetAccidentResults(this.item).then((response) => {
        this.loading = false;
        if (response.data.data) {
          this.data = response.data.data;
          this.getDisplayData()
        }
      });
    },
    loadTime() {
      this.item.startDate = AddDays(new Date(), -6);
      this.item.endDate = AddDays(new Date(), +1);
    },
    getDisplayData() {
      this.displayData = this.data.slice((this.filter.page - 1) * this.filter.pagesize, this.filter.page * this.filter.pagesize)
    },
    handleCurrentChange(val) {
      this.filter.page = val;
      this.getDisplayData();
    },
    handleSizeChange(val) {
      this.filter.pagesize = val
      this.getDisplayData();
    },
  },
  mounted() {
    this.loadTime();
    this.getData();
  },
};
</script>

<style lang="css" scoped>
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
}

.example-showcase .el-dropdown-link {
  cursor: pointer;
  color: var(--el-color-primary);
  display: flex;
  align-items: center;
}
</style>
